import { useVisualRefreshEnabled } from '../../core/hooks/useVisualRefreshEnabled.js';
import {
  EMTPY_STATE_ASSET_MAP,
  VISUAL_REFRESH_EMPTY_STATE_ASSET_MAP,
} from './assets/VisualPresetVariants.js';
import type { EmptyStateVisualPresetProps } from './types/empty-state-types.js';

/**  Based on the content subcontainer's min-width, spacing,
 * and visual container dimensions (320px + 64px + 320px)
 * @internal
 */
export const _MIN_CONTAINER_WIDTH = 704;

/**
 * @internal
 */
export function getHeadingVariant(
  size: 'small' | 'default' | 'large',
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
): {
  level: 1 | 2 | 3 | 4 | 5 | 6;
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
} {
  if (size === 'small') {
    return { level: 6, as: as ?? 'h6' };
  }

  if (size === 'large') {
    return { level: 1, as: as ?? 'h1' };
  }

  return { level: 3, as: as ?? 'h3' };
}

/**
 * @internal
 */
export function useVisualPresetCdnUrl(
  context: EmptyStateVisualPresetProps['context'],
  type: EmptyStateVisualPresetProps['type'],
  theme: 'light' | 'dark',
): string {
  if (useVisualRefreshEnabled()) {
    return VISUAL_REFRESH_EMPTY_STATE_ASSET_MAP[context][type][theme];
  }
  return EMTPY_STATE_ASSET_MAP[context][type][theme];
}
